import styled from '@emotion/styled';
import { ContentWrapper } from '@styles/globalStyles';

export const Container = styled.div`
  background-color: #f7f7f8;
  padding: 72px 0;

  @media screen and (max-width: 1350px) {
    form {
      padding: 40px 15px 60px 15px;
    }
  }

  @media screen and (max-width: 850px) {
    padding: 32px 0 48px 0;
  }
`;

export const Wrapper = styled(ContentWrapper)`
  text-align: center;

  button {
    margin-top: 56px;
  }
`;

export const Employers = styled.div`
  display: flex;
  gap: 32px;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;

  &:after {
    content: '';
    display: block;
    flex: auto;
  }
`;

export const TemporaryImage = styled.div`
  width: 100%;
  height: 130px;
  background-color: #212121;
`;

export const Grow = styled.div`
  flex: 1;
`;
